import { isNil } from 'lodash/fp';
import { useMemo } from 'react';
import styled from 'styled-components';
import { type EdmSocialMediaDataFragment } from '../../../../api/fragments/EdmSocialMediaData';
import { StyledImage, StyledNavigationLink } from './shared';

const StyledWebpageImage = styled(StyledImage)`
    width: 48px;
    height: 48px;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

type WebsiteSocialMediaProps = {
    socialMedia: EdmSocialMediaDataFragment[];
};

const WebsiteSocialMedia = ({ socialMedia }: WebsiteSocialMediaProps) => {
    const filteredSocialMedia = useMemo(() => socialMedia.filter(media => !isNil(media.icon)), [socialMedia]);

    if (!filteredSocialMedia.length) {
        return null;
    }

    return (
        <Container>
            {filteredSocialMedia.map(media => (
                <div key={media.id}>
                    <StyledNavigationLink href={`https://${media.url}`} target="_blank" isSocialMedia>
                        <StyledWebpageImage alt={media.altText} preview={false} src={media.icon.url} />
                    </StyledNavigationLink>
                </div>
            ))}
        </Container>
    );
};

export default WebsiteSocialMedia;
